import StatisticsActions from '../../../../actions/StatisticsActions';
import PublisherActions from '../../../../actions/PublisherActions';
import LinksActions from '../../../../actions/LinksActions';
import config from '../../../../config';
import store from '../../../../stores/redux';
import ReportComponent from "../../../../utils/ReportComponent/ReportComponent";
import {metrics} from "../../../../utils/ReportComponent/config";

const reportUtils = ReportComponent.utils;

export const actions = {
    search(state) {
        const user = store.getState().user;
        const count = state.count;
        const goalsState = store.getState().goals;

        let columns = reportUtils.getKeysMetric(state.metrics);
        if (!columns.length) {
            columns = reportUtils.getKeysMetric(reportUtils.getDefStrMetric());
        }

        const params = {
            publishers: [],
            group_by: state.groupBy,
            from_day: state.startDate.format(config.reportHourFormat),
            to_day: state.endDate.format(config.reportHourFormat),
            use_registered_date: '0',
            registered_from_day: state.startDate.format(config.reportHourFormat),
            registered_to_day: state.endDate.format(config.reportHourFormat),
            bind_actions: state.bindActions,
            timezone: state.timezone, // || user.timezone,
            only_for_traffic_in_period: state.onlyForTrafficInPeriod ? 1 : undefined,
            currency: user?.publisher?.account?.balance?.currency || 'USD',
            sort: state.sort,
            order: state.order,
            page: state.page,
            segments: state.segments && Object.keys(state.segments || {}).length ? JSON.stringify(state.segments) : undefined,
            count,
            columns: columns,
            totals: '1'
        };

        if (params.group_by === 'Goal' && !(goalsState && Array.isArray(goalsState.list) && goalsState.list.length)) {
            PublisherActions.getGoals({ count, page: config.initialPage });
        }

        StatisticsActions.searchData(params, () => {
            const dataStatistics = store.getState().statistics.data;

            // load minimal dictionary only when required for IDs to render correctly
            if (dataStatistics.ids.length) {
                const followUpParams = {
                    count,
                    ids: dataStatistics.ids
                };

                switch (dataStatistics.parameters.group_by) {
                case 'Goal':
                    PublisherActions.getGoals(followUpParams);
                    break;
                case 'Offer':
                    PublisherActions.getOffers(followUpParams);
                    break;
                case 'Link':
                    LinksActions.getListLinks(followUpParams);
                    break;
                default:
                    break;
            }
            }
        });
    },

    searchChart(state) {
        const user = store.getState().user;
        const count = config.reportItemsCount;

        let columns = reportUtils.getKeysMetric(state.metrics);
        if (!columns.length) {
            columns = reportUtils.getKeysMetric(reportUtils.getDefStrMetric());
        }

        const params = {
            publishers: [],
            group_by: state.groupByChart || actions.resolveDefaultChartGroupBy(state.startDate, state.endDate),
            from_day: state.startDate.format(config.reportHourFormat),
            to_day: state.endDate.format(config.reportHourFormat),
            use_registered_date: '0',
            registered_from_day: state.startDate.format(config.reportHourFormat),
            registered_to_day: state.endDate.format(config.reportHourFormat),
            bind_actions: state.bindActions,
            timezone: state.timezone, // || user.timezone,
            only_for_traffic_in_period: state.onlyForTrafficInPeriod ? 1 : undefined,
            currency: user?.publisher?.account?.balance?.currency || 'USD',
            sort: state.sort,
            order: state.order,
            segments: JSON.stringify(state.segments),
            count,
            columns: columns,
            totals: '1'
        };

        StatisticsActions.searchDataChart(params);
    },

    resolveDefaultChartGroupBy: function (startDate, endDate) {
        const days = Math.abs(endDate.diff(startDate, 'days'));

        if (days <= 1) {
            return 'Hour';
        } else if (days <= 30) {
            return 'Day';
        } else if (days <= 90) {
            return 'Week';
        } else {
            return 'Month';
        }
    }
};
